import React from "react";
import PropTypes from "prop-types";
import {
  Type,
  Card,
  DialogTitle,
  DialogTitleActions,
  ContentFormatter,
  Dialog,
  DialogScroll,
} from "@ebscois/react-component-library";

const ContentRecommendationsGradingDialog = ({ isOpen, onClose, content }) => (
  <Dialog
    isOpen={isOpen}
    maxWidth="lg"
    hasMaxHeight
    onRequestClose={onClose}
    aria-labelledby="recommendations-gradient-dialog-title"
  >
    <DialogTitle padding="lg" paddingBottom="0">
      <Type
        id="recommendations-gradient-dialog-title"
        element="h2"
        fontFamily="secondary"
      >
        {content?.title}
      </Type>
      <DialogTitleActions onRequestClose={onClose} isFloating />
    </DialogTitle>
    <DialogScroll>
      <Card padding="lg" paddingTop="md">
        <ContentFormatter children={content?.content} />
      </Card>
    </DialogScroll>
  </Dialog>
);

ContentRecommendationsGradingDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

ContentRecommendationsGradingDialog.defaultProps = {
  isOpen: false,
};

ContentRecommendationsGradingDialog.displayName =
  "ContentRecommendationsGradingDialog";

export default ContentRecommendationsGradingDialog;
